<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Different types of alerts and colors" />

    <vc-alert>Default alert, no icon, not dismissable, default color.</vc-alert>

    <vc-alert color="warning" dismissable icon="mdi-github-circle">
      Dismissable warning color alert with icon.
    </vc-alert>

    <vc-alert color="success" dismissable icon="thumb_up">
      Success alert with icon.
    </vc-alert>

    <vc-alert color="error" icon="error">
      Error alert, not dismissable.
    </vc-alert>

    <vc-alert color="pink" icon="mdi-lastfm" dismissable>
      Pink alert with icon.
    </vc-alert>

    <vc-alert color="green l-200" icon="mdi-lastfm" :dark="false" dismissable>
      Green alert with icon and light theme.
    </vc-alert>

    <vc-alert dismissable>Dismissable primary color alert.</vc-alert>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'AlertPage',
  data () {
    return {
      title: null,
      description: null
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/alert.vue